<template>
  <div class="section" id="testimonials">
    <div class="total_wrap">
      <div class="top">
        <div class="title">Testimonials</div>
      </div>
      <div class="bottom">
        <div class="item">
          <div class="image">
            <img src="./1.jpg" alt="" />
          </div>
          <div class="title">Lindsay Rune</div>
          <div class="sub_title">Student</div>
          <div class="data">
            I recommend Aria to every business owner or growth leader that wants
            to take his company to the next level.
          </div>
        </div>
        <div class="item">
          <div class="image">
            <img src="./2.jpg" alt="" />
          </div>
          <div class="title">Marsha Singer</div>
          <div class="sub_title">Teacher</div>
          <div class="data">
            I purchased the Growth Accelerator service pack a few years ago and
            I renewed the contract each year.
          </div>
        </div>
        <div class="item">
          <div class="image">
            <img src="./3.jpg" alt="" />
          </div>
          <div class="title">Ronald Spice</div>
          <div class="sub_title">Student</div>
          <div class="data">
            My goals for using Aria's services seemed high when I first set them
            but they've met them with no problems.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {},
  },
};
</script>
<style>
.section#testimonials {
  padding: 1rem 2.5rem;
  min-height: calc(100vh - 75px);
  display: flex;
  align-items: center;
}
.section#testimonials .top {
  width: 100%;
  text-align: center;
}
.section#testimonials .top .title {
  font-size: 3rem;
  font-family: "Volkhov", serif;
  font-weight: 400;
  margin-bottom: 4rem;
}
.section#testimonials .bottom {
  display: flex;
  justify-content: center;
  margin-top: 5rem;
}

.section#testimonials .bottom img {
  width: 70px;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.section#testimonials .bottom .item {
  padding: 2rem 5rem;
  text-align: center;
}
.section#testimonials .bottom .item .image {
  width: 100%;
  margin-bottom: 1rem;
}
.section#testimonials .bottom .item .title {
  font-size: 1rem;
  font-weight: 600;
}
.section#testimonials .bottom .item .sub_title {
  font-size: 0.9rem;
  color: #545a66;
}
.section#testimonials .bottom .item .data {
  margin-top: 1rem;
  position: relative;
}
.section#testimonials .bottom .item .data:before {
  content: "\201C";
  color: #ea3c49;
  font-size: 2.5rem;
  font-weight: bold;
  font-family: cursive;
  display: block;
  text-align: left;
  height: 3rem;
}
</style>